import { CdkMenuModule } from "@angular/cdk/menu";
import { CommonModule } from "@angular/common";
import { Component, inject, input, model, output, signal } from "@angular/core";
import {
    DocumentTemplateCategoryDto,
    DocumentTemplateCategoryService,
    ProductCategoryDto,
    ProductCategoryService,
} from "@malirang/api-client";
import {
    Icon,
    IconButton,
    Menu,
    MenuOption,
    ToastService,
} from "@malirang/front-share";
import { CdkDrag, CdkDragHandle } from "@angular/cdk/drag-drop";
import { ProductCategoryFormComponent } from "../product-category-form/product-category-form.component";

@Component({
    selector: "app-product-category-item",
    templateUrl: "./product-category-item.component.html",
    styleUrls: ["./product-category-item.component.css"],
    imports: [
        Icon,
        CommonModule,
        IconButton,
        ProductCategoryFormComponent,
        CdkMenuModule,
        Menu,
        MenuOption,
        CdkDrag,
        CdkDragHandle,
    ],
})
export class ProductCategoryItemComponent {
    readonly categoryService = inject(ProductCategoryService);
    readonly toastService = inject(ToastService);

    category = input.required<ProductCategoryDto>();
    refresh = output<void>();
    isUpdate = signal(false);
    formValue = model<string>("");

    cancel() {
        this.isUpdate.set(false);
    }

    handleUpdate() {
        this.isUpdate.set(true);
        this.formValue.set(this.category().name);
    }

    handleDelete() {
        this.categoryService
            .productCategoryControllerDelete({
                id: this.category().id,
            })
            .subscribe({
                next: () => {
                    this.refresh.emit();
                    this.toastService.success("카테고리가 삭제되었습니다.");
                },
                error: (err) => {
                    this.toastService.error(err.message);
                },
            });
    }

    submit() {
        if (!this.formValue()) {
            this.toastService.error("카테고리 이름을 입력해주세요.");
            return;
        }

        this.categoryService
            .productCategoryControllerUpdate({
                id: this.category().id,
                body: {
                    name: this.formValue() || "",
                },
            })
            .subscribe({
                next: () => {
                    this.isUpdate.set(false);
                    this.refresh.emit();
                    this.toastService.success("카테고리가 수정되었습니다.");
                },
                error: (err) => {
                    this.toastService.error(err.message);
                },
            });
    }
}
